
export const makeQuery = (obj) => {
    let str = '';
    for (const [key, value] of Object.entries(obj)) {

        if(value === '') continue
        else {
            if (Object.keys(obj).at(-1) === key)  str += `${key}=${value}`
            else  str += `${key}=${value}&`
        }
    }
    return str
}